<template>
    <div>
        <!-- Escalate invoice/contract modals -->
        <InvoiceEscalateModals
            ref="InvoiceEscalateModals"
            :showEscalation="showEscalation"
            :showOutEscalation="showOutEscalation"
        />

        <!-- Resend invoice modal -->
        <b-modal :active.sync="resendModalOpen" class="invitemodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Opnieuw versturen</p></header>
                <section class="modal-card-body text-left" style="overflow: hidden;border-radius:0;">
                    Weet je zeker dat je de {{ type == 'credit' ? 'creditfactuur' : 'factuur' }} opnieuw wilt versturen?
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" :disabled="loading" @click="resendModalOpen = false">Annuleren</b-button>
                    <b-button type="is-success" @click="resend" :loading="loading">Versturen</b-button>
                </footer>
            </div>
        </b-modal>

        <!-- Cancel creditinvoice modal -->
        <b-modal :active.sync="cancelModalOpen" class="invitemodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Annuleren</p></header>
                <section class="modal-card-body text-left" style="overflow: hidden;border-radius:0;">
                    Weet je zeker dat je de {{ type == 'credit' ? 'creditfactuur' : 'factuur' }} wilt annuleren?
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" :disabled="loading" @click="cancelModalOpen = false">Sluiten</b-button>
                    <b-button type="is-success" @click="cancel" :loading="loading">Annuleren</b-button>
                </footer>
            </div>
        </b-modal>

        <div class="invoice-options-dropdown">
            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: type === 'geescaleerd' ? 'EscalationRecord' : 'InvoicesRecord', params: {type: type, id: record.id} }">Bekijken</b-button>
            <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left" v-if="showDropdown">
                <template #trigger>
                    <b-button
                        type="is-dark"
                        size="is-small"
                        icon-right="chevron-down" />
                </template>

                <b-dropdown-item aria-role="listitem" :disabled="!resendPossible" @click="resendModalOpen = true">Opnieuw versturen</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" v-if="type == 'credit'" :disabled="!_.isNull(record.send_at)" @click="cancelModalOpen = true">Annuleren</b-dropdown-item>
                <router-link v-if="!hideCreditButton && !user.deurwaarder" class="dropdown-item" aria-role="listitem" has-link :to="{ name: 'InvoicesRecord', params: {type: type, id: record.id}, query: {'creditinvoice': true} }">Maak creditfactuur</router-link>
                <b-dropdown-item aria-role="listitem" v-if="showEscalation && !user.deurwaarder" :disabled="cantEscalate" @click="$refs['InvoiceEscalateModals'].toggleEscalateModal({esc_invoice: record.id, esc_contract: _.has(record, 'contract.id') ? record.contract.id : record.contract ? record.contract : null})">{{ escalationName == 'escalatie' ? 'Escaleren' : 'Deurwaarder' }}</b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import toastMixin from '@/mixins/toastMixins.js'
import escalationMixin from '@/mixins/escalationMixin.js'
import InvoiceEscalateModals from '@/vue/invoices/components/InvoiceEscalateModals'

export default {
    name: 'InvoiceOptionsDropdown',

    mixins: [toastMixin, escalationMixin],

    components: {
        InvoiceEscalateModals
    },

    props: {
        type: {
            type: String,
            default: 'recent',
            required: false
        },

        record: {
            type: Object,
            required: true
        },

        showDropdown: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        resendPossible() {
            return !_.isNull(this.record.send_at)
        },

        user() {
            return this.$store.state.user
        },

        hideCreditButton() {
            let hideButton = false

            if(_.has(this.user.organisation_settings, 'strictcredits') && this.user.organisation_settings.strictcredits == 1 && (this.user.role != 'admin' && !this.user.is_admin) || (this.type == 'credit')){
                hideButton = true
            }

            return hideButton
        }
    },

    data() {
        return {
            loading: false,
            resendModalOpen: false,
            cancelModalOpen: false
        }
    },

    methods: {
        resend() {
            this.loading = true

            axios.post('/api/invoices/'+this.record.id+'/resend', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage(`Opnieuw versturen van ${this.type == 'credit' ? 'creditfactuur' : 'factuur'} ingepland!`)
                this.$emit('reloadInvoices')
            }).catch((e) => {
                console.error(e)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
            }).then(() => {
                this.loading = false
                this.resendModalOpen = false
            })
        },

        cancel() {
            this.loading = true

            axios.post('/api/invoices/'+this.record.id+'/cancel', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage(`${this.type == 'credit' ? 'Creditfactuur' : 'Factuur'} is geannuleerd!`)
                this.$emit('reloadInvoices')
            }).catch((e) => {
                console.error(e)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
            }).then(() => {
                this.loading = false
                this.cancelModalOpen = false
            })

        }
    }
}
</script>